// extracted by mini-css-extract-plugin
export default {"container":"styles_container__IrjRv","label":"styles_label__AwJVm","icon":"styles_icon__E3QA7","iconSpace":"styles_iconSpace__uAj-q","blueIcon":"styles_blueIcon__YR0qT"};